import { render, staticRenderFns } from "./FlyteStickyNotification.vue?vue&type=template&id=ff6477a8&scoped=true&"
import script from "./FlyteStickyNotification.vue?vue&type=script&lang=js&"
export * from "./FlyteStickyNotification.vue?vue&type=script&lang=js&"
import style0 from "./FlyteStickyNotification.vue?vue&type=style&index=0&id=ff6477a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6477a8",
  null
  
)

export default component.exports